import { render, staticRenderFns } from "./TournamentTeamsRatingMlbbInfo.vue?vue&type=template&id=def5d284&scoped=true"
import script from "./TournamentTeamsRatingMlbbInfo.vue?vue&type=script&lang=js"
export * from "./TournamentTeamsRatingMlbbInfo.vue?vue&type=script&lang=js"
import style0 from "./TournamentTeamsRatingMlbbInfo.vue?vue&type=style&index=0&id=def5d284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5d284",
  null
  
)

export default component.exports